import React from 'react';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const MobileNavigation = ({ isOpen, onClose, navigationItems, onNavigate, activeRoute }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[1100] transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Mobile Menu */}
      <div className="fixed top-0 right-0 bottom-0 w-[280px] bg-gradient-to-b from-[#2E8B8B] to-[#1A6B6B] z-[1200] shadow-2xl transform transition-transform duration-300">
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-white/20">
            <span className="text-lg font-bold text-white">Menu</span>
            <button
              onClick={onClose}
              className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300"
              aria-label="Close menu"
            >
              <Icon name="X" size={20} color="#FFFFFF" />
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 overflow-y-auto p-4">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => onNavigate(item?.path)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-all duration-300 ${
                  activeRoute === item?.path
                    ? 'bg-white/20 text-white backdrop-blur-sm' :'text-white/90 hover:bg-white/10'
                }`}
              >
                <Icon name={item?.icon} size={20} />
                <span className="text-base font-medium">{item?.label}</span>
              </button>
            ))}
          </nav>

          {/* Action Buttons */}
          <div className="p-4 border-t border-white/20 space-y-3">
            <Button
              variant="default"
              size="default"
              className="w-full bg-[#F4A261] hover:bg-[#E89451] text-gray-900 font-semibold border-0"
              iconName="Calendar"
              iconPosition="left"
              onClick={() => onNavigate('/itinerary-builder')}
            >
              Itinerary Builder
            </Button>
            <button className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-all duration-300">
              <Icon name="Heart" size={18} />
              <span className="text-sm font-medium">Favorites</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavigation;